import { styled } from '@linaria/react';
// intl-next Link не совместим с linaria.
// eslint-disable-next-line no-restricted-imports
import Link from 'next/link';

import { MqDesktop, MqTablet } from '~theme/media';

export const BotHeaderContainer = styled.div`
	position: absolute;
	z-index: 1;
	top: 16px;
	right: 40px;
	display: none;
	align-self: end;

	${MqTablet} {
		display: flex;
	}

	${MqDesktop} {
		right: 32px;
	}
`;

export const BotLink = styled(Link)`
	display: flex;
	align-items: center;
	padding: 2px 12px 2px 2px;
	border-radius: var(--radius-xl);
	margin-right: 8px;
	background-color: var(--color-white-xs);
`;
